import { useState, useEffect } from 'react'

export interface HeaderProps {}

export const useHeader = (props: HeaderProps) => {
  const [isMobileNavActive, setIsMobileNavActive] = useState(false)
  const [activeSection, setActiveSection] = useState('hero')

  const navLinks = [
    { href: '#hero', label: 'Home' },
    { href: '#about', label: 'About' },
    { href: '#features', label: 'Features' },
    { href: '#how-it-works', label: 'How It Works' },
    { href: '#pricing', label: 'Pricing' },
    { href: '#faq', label: 'FAQ' },
    { href: '#contact', label: 'Contact' },
  ]

  const toggleMobileNav = (toggle?: boolean) => {
    if (typeof toggle === 'boolean') setIsMobileNavActive(toggle)
    else setIsMobileNavActive(!isMobileNavActive)
  }

  useEffect(() => {
    const sections = document.querySelectorAll('section[id]')

    const handleScroll = () => {
      let current = 'hero'
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect()
        if (rect.top <= 100 && rect.bottom > 100) {
          current = section.id
        }
      })
      setActiveSection(current)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return {
    ...props,
    activeSection,
    navLinks,
    isMobileNavActive,
    toggleMobileNav,
  }
}
